/** Entity types supported by the files upload API. */
export enum ResourceType {
  USER_TERMINAL = 'USER_TERMINAL',
}

/** Metadata for a single file when requesting signed upload URLs. */
export interface FileUploadMeta {
  fileName: string;
  contentType: string;
  sizeBytes: number;
}

export interface UploadUrlRequest {
  resourceType: ResourceType;
  resourceId: string;
  files: FileUploadMeta[];
}

/** One signed-upload slot returned by `/files/upload-url`. */
export interface UploadUrlFileResult {
  fileId: string;
  uploadUrl: string;
  fileName?: string;
  method: string;
  headers?: {
    contentType: string;
  };
  expiresAt: string;
}

export interface UploadUrlResponseData {
  resourceType: ResourceType;
  resourceId: string;
  uploads?: UploadUrlFileResult[] | undefined;
}

export interface UploadUrlResponse {
  data: UploadUrlResponseData;
}

export interface UploadCompleteRequest {
  resourceType: ResourceType;
  resourceId: string;
  fileIds: string[];
}

export interface UploadCompleteResponse {
  message?: string;
  data?: unknown;
}

/** Input for the full client-side upload orchestration. */
export interface UploadFilesInput {
  resourceType: ResourceType;
  resourceId: string;
  files: File[];
}


export interface FileEntityResponseData {
  fileId: string;
  url: string;
}

export interface FileEntityResponse {
  data: {
    resourceType: ResourceType;
    resourceId: string;
    files?: FileEntityResponseData[] | undefined;
  };
}